<template>
    <!-- 右侧代办列表和已办列表的todolist --> 
			<div class="todo-list bg-center">
			   <div class="left-bg-title bg-center pd10tb">
			   <img src="../../assets/images/icon6.png" class="icon"/>
			   {{ todoTitle }}</div>
			   <div class="parent-boxs notice-effect">
				   <ul class="info-list">
					   <li
						@click = 'showNewsInfo(news.id)' 
						v-for="(news,index) in newsList" 
						:key="news.id">{{ index + 1 }}.{{ news.title }}</li>
				   </ul>
				</div>   
			</div>
</template>

<script>
import {showNoticeDetail} from '../../api/home.js';
import $ from 'jquery'
export default {
    props: ['todoTitle','newsList'],
    methods: {
        //点击每个新闻li标签的弹出显示
        showNewsInfo(id) {
            showNoticeDetail(id)
            .then(res => {
                let data=res.data;
                let list=data.content.split("color: rgb(51, 51, 51);");
                data.content=list.join("")
                this.$store.commit('changeNewsData', data);
            }).catch(err => {
                console.log(err);
            })
            this.$store.commit('openNewsFade');
        },
		autoScrollEffect()
		{
			let time = new Date();
			let that = this;
			$(function(){
				$('.notice-effect').find("ul").stop(true,true).animate({
					marginTop : "-23px"  
				},500,function(){  
					$(this).css({marginTop : "0px"}).find("li:first").appendTo(this);  
				})
				setTimeout(function() {
					if(new Date() - time > 500)
					{
						that.autoScrollEffect();	
					}
				}, 6000);  
			}) 
		}
    },
	mounted:function(){
		this.autoScrollEffect();
	}
}
</script>

<style lang='less'>
    //引入主色调样式
    @import '../../assets/css/mainColor.less';
    //新闻列表样式
    .todo-list {
        position: relative;
        right: 20px;
        width: 100%;
        height: 47%;
        margin-top: 20px;
        max-width: 540px;
        border-top: 1px solid transparent;
        box-sizing: border-box;
        padding: 5px;
        padding-left: 20px;
        background-image: url('../../assets/images/down-right-div.png');  
		.parent-boxs{
			height: 138px;
			overflow: hidden;
			margin-top: 31px;
		}
			.info-list {
				display: flex;
				flex-direction: column;
				justify-content: flex-start;
				box-sizing: border-box;
				height:100%;
				li {
					min-height:22px;
					height:23px;
					line-height: 23px;
					color: @mainColor;
					cursor: pointer;
					font-size: 14px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					width: 95%;
				}
				li:hover {
					text-decoration: underline;
					color: #4FCCFF;
				}
        }
    }
.left-bg-title{
	background: none;
		line-height: 20px;
		left: 10px;
		top: 7px;
		color: #4FCCFF;
		width: auto;
		min-width: auto;
		max-width: 130px;
		.icon{
			width: 20px;
			height: 20px;
			float: left;
			margin-right: 8px;
		}
}
</style>